<template src="./index.html"></template>
<script>

export default {
	name: '',
	components: {
		
	},
	props: {
		repairallDiag: {
			type: Boolean,
			default: false
		},
		
	},
	watch: {
		repairallDiag: function(indexVal, oldVal) {
			if (indexVal) {
				
			}
		}
	},
	data: function() {
		return {
			
		};
	},
	created() {},
	methods: {
		closediag() {
			this.$emit('closediag', false);
		},
		forsubmit(){
			this.$emit('closediag', false);	
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
